<template>
	<v-card width="400" :ripple="!loading" :color="color" :dark="isActive" v-on="{ click: !loading ? toggle : null }" :disabled="loading">
		<v-card-title>
			<v-icon left>{{ icon[service.type] }}</v-icon>
			{{ service.name }}
		</v-card-title>
		<v-card-subtitle class="d-flex align-center justify-space-between">
			<div><v-icon left>mdi-clock-outline</v-icon>{{ service.duration }} {{ $t('duration.minutes') }}</div>
			<div>{{ $n(service.price, 'currency') }}</div>
		</v-card-subtitle>
		<v-card-text>
			{{ service.description }}
		</v-card-text>
		<v-card-text>
			{{ service.type === 'other' ? 'doplňek' : 'hlavní služba' }}
		</v-card-text>

		<v-overlay absolute :value="loading">
			<v-progress-circular indeterminate size="64" width="2"></v-progress-circular>
		</v-overlay>
	</v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import serviceMixin from '~/mixins/serviceMixin'

export default {
	name: 'Service',

	mixins: [serviceMixin],

	props: {
		service: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			loading: false
		}
	},

	computed: {
		...mapGetters({
			services: 'auth/servicesId'
		}),
		color() {
			return this.isActive ? 'success' : 'grey lighten-5'
		},
		isActive() {
			return this.services.includes(this.service.id)
		}
	},

	methods: {
		...mapMutations({
			fetchServices: 'auth/FETCH_SERVICES' // map `this.add()` to `this.$store.commit('increment')`
		}),
		async toggle() {
			this.loading = true

			let { data } = await this.$http.patch('/barber/services', this._.pick(this.service, ['id']))
			this.fetchServices(data)
			this.loading = false
		}
	}
}
</script>
